module.exports = __webpack_public_path__ + "static/img/fullscreen-image_keep-on-top.eb87b0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fundamentals/fullscreen-image_keep-on-top.png
// module id = rKJO
// module chunks = 0